var map = {
	"./add-user.svg": 34461,
	"./arr-m-r.svg": 81720,
	"./arrow-left.svg": 39569,
	"./arrow-left2.svg": 57393,
	"./arrow-right.svg": 11164,
	"./arrow-right2.svg": 90118,
	"./ava-def.svg": 1382,
	"./bookmark-full.svg": 88852,
	"./bookmark.svg": 37406,
	"./calendar-check.svg": 52167,
	"./calendar-plus.svg": 45357,
	"./calendar.svg": 80564,
	"./calendar2.svg": 83342,
	"./calendar3.svg": 21279,
	"./check.svg": 63022,
	"./chevron-left.svg": 63547,
	"./chevron-right.svg": 49278,
	"./circ-galka.svg": 84504,
	"./clock.svg": 22796,
	"./download.svg": 39326,
	"./file.svg": 48372,
	"./folder.svg": 50262,
	"./gefera/arrow-down.svg": 88381,
	"./gefera/basket.svg": 5379,
	"./gefera/clock.svg": 34633,
	"./gefera/crose.svg": 63177,
	"./gefera/heart-fill.svg": 65539,
	"./gefera/list-icon.svg": 6505,
	"./gefera/location-icon.svg": 69546,
	"./gefera/search.svg": 39821,
	"./gefera/speaker.svg": 19812,
	"./gefera/tale-icon.svg": 54661,
	"./globe.svg": 68365,
	"./ic-edit.svg": 69535,
	"./ic-pay.svg": 25783,
	"./ico-calendar.svg": 98228,
	"./ico-del.svg": 88585,
	"./ico-draft.svg": 21931,
	"./ico-favorite.svg": 46794,
	"./ico-galka.svg": 44938,
	"./ico-h-calendar.svg": 90305,
	"./ico-h-favorite.svg": 48227,
	"./ico-h-message.svg": 74704,
	"./ico-h-notification.svg": 37902,
	"./ico-h-user.svg": 90498,
	"./ico-pdf.svg": 20544,
	"./ico-plus-circ.svg": 44870,
	"./ico-save-draft.svg": 39919,
	"./ico-time.svg": 77105,
	"./ico-user.svg": 78159,
	"./map-marker.svg": 68251,
	"./mf-logo.svg": 38761,
	"./mf-small.svg": 12377,
	"./plane.svg": 73140,
	"./plane_old.svg": 22222,
	"./plus.svg": 38178,
	"./search.svg": 72310,
	"./shield.svg": 97853,
	"./stars.svg": 35721,
	"./tag-master.svg": 87441,
	"./tag-play.svg": 71649,
	"./trophy.svg": 99132,
	"./user.svg": 62191,
	"./users.svg": 25774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45851;